const colors = [
  'rgba(228,26,28, 0.8)',
  'rgba(55,126,184, 0.8)',
  'rgba(77,175,74, 0.8)',
  'rgba(152,78,163, 0.8)',
  'rgba(255,127,0, 0.8)',
  'rgba(255,255,51, 0.8)',
  'rgba(166,86,40, 0.8)',
  'rgba(247,129,191, 0.8)',
  'rgba(153,153,153, 0.8)'
];

const borderColors = [
  'rgba(228,26,28)',
  'rgba(55,126,184)',
  'rgba(77,175,74)',
  'rgba(152,78,163)',
  'rgba(255,127,0)',
  'rgba(255,255,51)',
  'rgba(166,86,40)',
  'rgba(247,129,191)',
  'rgba(153,153,153)'
];

export {
  colors,
  borderColors
};



// WEBPACK FOOTER //
// ./src/config/chartColors.js